import { Currency } from '@seapoint/server/enums';
import { TriangleAlert } from 'lucide-react';
import { Button } from '../../../../design-system/button/button';
import { Inline } from '../../../../design-system/inline/inline';
import { Stack } from '../../../../design-system/stack/stack';

type CurrencyAccountsNotFoundProps = {
  currency: Currency;
  onOpenAccount: () => void;
};

export const CurrencyAccountsNotFound = ({ currency, onOpenAccount }: CurrencyAccountsNotFoundProps) => {
  return (
    <Stack space={3} align="stretch" className="rounded-lg border border-seapoint-gray-border bg-white p-5">
      <Inline justify="center">
        <div className="h-5 w-5">
          <TriangleAlert className="h-full w-full" color="#FF531D" />
        </div>

        <p className="text-center text-base font-medium text-black">{`You don't have an account in ${currency}`}</p>
      </Inline>

      <Button variant="default" onClick={onOpenAccount}>
        {`Open ${currency} account`}
      </Button>
    </Stack>
  );
};
